'use client';
import { createContext, useMemo } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

function _define_property(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = n, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function(t) {
            _define_property(e, t, n[t]);
        });
    }
    return e;
}
function useMenuList(e, n, r) {
    return useMemo(()=>({
            menuState: r,
            menuProps: _object_spread({}, e),
            menuRef: n
        }), [
        r,
        e,
        n
    ]);
}
const SwanMenuListContext = createContext(void 0);
function useSwanMenuListContext() {
    return useNonNullishContext(SwanMenuListContext);
}

export { SwanMenuListContext, useMenuList, useSwanMenuListContext };
